const $ = jQuery.noConflict();

const StyleSelect = () => {
    const selects = $('select:not([name="attribute_pa_packs"]):not([name="billing_state"])');

    selects.each((index, element) => {
        if (!$(element).closest('form').parent().hasClass('gform_wrapper') && !$(element).closest('form').hasClass('wpcf7-form')) {
            $(element).select2({
                minimumResultsForSearch: Infinity,
                width: 'resolve',
                dropdownAutoWidth: true,
                allowClear: true,
            });
        }
    });

    if ($('.page-hero .gform_wrapper').length) {
        $('.page-hero .form-buttons-wrapper').hide();
        $('body').addClass('gforms-page');
    }
};

export default StyleSelect;
